export const startPlantUmlText = `@startuml
Bob -> Alice : hello
@enduml`;
